export default "__VITE_ASSET__5fc9083c__"